module.exports = __webpack_public_path__ + "static/media/bank.8e3e191f.svg";